const userTableHeaderList = [
  {
    id: 1,
    name: "User Name ",
  },

  {
    id: 2,
    name: "Email",
  },
  {
    id: 3,
    name: "Phone Number ",
  },
  {
    id: 4,
    name: "Status",
  },
];
const journeyTableHeaderList = [
  {
    id: 1,
    name: "Image ",
  },

  {
    id: 2,
    name: "Name",
  },
  {
    id: 3,
    name: "Description ",
  },
  {
    id: 4,
    name: "Status",
  },
];

const journeyData = [
  {
    image: "../assets/logos/main-logo.svg",
    name: "Test",
    description: " shshs sfsfhs",
    status: 1,
  },
  {
    image: "../assets/logos/main-logo.svg",
    name: "Test",
    description: " shshs sfsfhs",
    status: 1,
  },
  {
    image: "../assets/logos/main-logo.svg",
    name: "Test",
    description: " shshs sfsfhs",
    status: 1,
  },
  {
    image: "../assets/logos/main-logo.svg",
    name: "Test",
    description: " shshs sfsfhs",
    status: 1,
  },
];
const leaderBoardTableHeaderList = [
  {
    id: 1,
    name: "Rank",
  },
  {
    id: 2,
    name: "User Image",
  },
  {
    id: 3,
    name: "User Name ",
  },

  {
    id: 4,
    name: "Email",
  },

  { id: 5, name: "Points" },
];
const paymentTableHeaderList = [
  {
    id: 1,
    name: "Transaction ID",
  },
  {
    id: 2,
    name: "Customer",
  },
  {
    id: 3,
    name: "Journey Name ",
  },

  {
    id: 4,
    name: "Amount",
  },

  { id: 5, name: "Status" },
  { id: 6, name: "Date" },
];
export {
  userTableHeaderList,
  journeyTableHeaderList,
  journeyData,
  leaderBoardTableHeaderList,
  paymentTableHeaderList,
};
